'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/assign/index.js
// module id = 17
// module chunks = 0